import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { SendIcon } from "../../../components/icons";
import { useSalesArguments } from "../hooks";

export const SalesArguments: React.FC = () => {
  const navigate = useNavigate();
  const { data, loading } = useSalesArguments();
  const [search, setSearch] = useState("");

  const results = (data?.salesArguments?.results ?? []).filter((argument) => {
    const query = search.trim().toLowerCase();
    if (!query) return true;
    return (
      argument.theme.toLowerCase().includes(query) ||
      argument.content.toLowerCase().includes(query)
    );
  });

  return (
    <>
      <Header
        title="Aide à la vente"
        subtitle="Bibliothèque d'argumentaires commerciaux"
        buttons={[
          {
            actionText: "Importer un lot",
            bgColor: "gray",
            textColor: "white",
            link: `/sales-arguments/import`,
            icon: <SendIcon />,
          },
          {
            actionText: "Nouvel argumentaire",
            bgColor: "indigo",
            textColor: "white",
            link: `/sales-argument/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <div className="relative mb-4 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
          <input
            className="input w-full pl-9"
            placeholder="Rechercher un argumentaire..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {loading ? (
          <Loading />
        ) : !results.length ? (
          <div className="p-4 bg-white shadow rounded">
            <EmptyList text="Aucun argumentaire" />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {results.map((argument) => (
              <div
                key={`sales-argument-${argument.id}`}
                className="card cursor-pointer hover:shadow-lg transition-shadow"
                onClick={() => navigate(`/sales-argument/${argument.id}/update`)}
              >
                <p className="font-semibold text-gray-900 dark:text-zinc-100 mb-2">
                  {argument.theme}
                </p>
                <p className="text-sm text-gray-600 dark:text-zinc-400 whitespace-pre-line line-clamp-6">
                  {argument.content}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
